export default __webpack_public_path__ + "static/media/IconDesc_NuclearWaste.256.8916a370.png";